import { useNotification } from "@/shared/feedback/notification";
import { FieldsType } from "./types";
import { useTranslations } from "use-intl";
import { useMutation } from "@apollo/client";
import { SAVE_DYNAMIC_ATTRIBUTE } from "../api/save-dynamic-attribute";
import { GET_ENTITY_ATTRIBUTES } from "@/modules/dynamic-attributes/widgets/dynamic-attribute-editor/api/get-entity-attributes";

export function useSaveAttribute({
  afterSubmit,
  entity,
}: {
  afterSubmit?: () => void;
  entity?: FieldsType;
}) {
  const notify = useNotification();
  const t = useTranslations("AttributeForm");

  const [saveAttribute] = useMutation(SAVE_DYNAMIC_ATTRIBUTE, {
    refetchQueries: [GET_ENTITY_ATTRIBUTES],
  });

  const save = async (attribute: FieldsType) => {
    await saveAttribute({
      variables: {
        attribute,
      },
    });

    notify?.success({
      message: entity ? t("Attribute updated") : t("Attribute saved"),
    });

    afterSubmit?.();
  };

  return {
    save,
  };
}
